import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonButton, IonIcon } from '@ionic/react';
import { swapHorizontalOutline, restaurantOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useCollettivaEnabled } from '../lib/data/queries.js';

// T-215 / T-225: accesso rapido al modulo ristorazione collettiva DENTRO la
// scheda Magazzino. "Scheda di produzione" e "Spedizioni / DDT" sono state
// promosse a quadrati nella Dashboard (TodayPage); qui resta solo il
// "Trasferimento merce" interno tra sedi, che è l'operazione del magazziniere
// e vive naturalmente nel magazzino. Renderizza nulla per i tenant ristorante
// (flag off) → costo zero per gli utenti esistenti.
export function CollettivaQuickNav(): JSX.Element | null {
  const enabled = useCollettivaEnabled();
  const history = useHistory();
  if (!enabled) return null;
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle style={{ fontSize: '1rem' }}>Ristorazione collettiva</IonCardTitle>
      </IonCardHeader>
      <IonCardContent style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <IonButton size="small" fill="outline" onClick={() => history.push('/warehouse/transfer')}>
          <IonIcon slot="start" icon={swapHorizontalOutline} />
          Trasferimento merce
        </IonButton>
        {/* T-276: richieste di fornitura dalle destinazioni (con foto). Il tile
            responsabile dedicato arriverà con T-277. */}
        <IonButton size="small" fill="outline" onClick={() => history.push('/warehouse/supply-requests')}>
          <IonIcon slot="start" icon={restaurantOutline} />
          Richieste di fornitura
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
}
